import styled from '@emotion/styled'
import { Button } from 'antd'
import { colors, elements } from 'style/theme'

export const StyledNewScanContainer = styled.div({
	display: 'grid',
	gridTemplateColumns: 'minmax(min-content, 774px) minmax(min-content, 300px)',
	alignItems: 'start',
	gridGap: 50
})
export const StyledNewScan = styled.div({
	background: colors.brandWhite,
	border: elements.brandBorder,

	borderRadius: elements.brandBorderRadius,
	width: 774,
	'.ant-tabs-bar': {
		display: 'none'
	},
	'.ant-form-explain': {
		position: 'absolute',
		right: 0,
		top: -28
	}
})

export const NewScanHeader = styled.div({
	height: 220,
	padding: '30px 25px',
	borderRadius: `${elements.brandBorderRadius}px ${elements.brandBorderRadius}px 0 0`,
})

export const HeaderTitle = styled.h1({
	fontWeight: 500,
	padding: '0 30px',
	marginBottom: 20
})

export const NewScanSteps = styled.div({
	borderRadius: elements.brandBorderRadius,
	background: colors.brandLight,
	border: elements.brandBorder,
	padding: 25,
})

export const NewScanContent = styled.div({
	padding: '5px 60px 30px'
})

export const NewScanFooter = styled.div({
	height: 74,
	padding: '10px 50px',
	borderRadius: `0 0 ${elements.brandBorderRadius}px ${elements.brandBorderRadius}px`,
	background: '#FAFCFD',
	borderTop: elements.brandBorder,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'flex-end'
})
export const MainActionButton = styled(Button)({
	marginRight: 8,
	width: 160,
	'&:last-child': {
		marginRight: 0,
	}
})

export const PanelsContent = styled.div({
	marginTop: 30
})

export const StyledSelectedList = styled.div({
	marginBottom: 30
})

export const SaveItemButton = styled(Button)({
	background: '#F0F2F9',
	color: colors.brandLink,
	border: 'none',
	'&:hover, &:active': {
		background: '#F0F2F9',
	}
})

export const SaveItemButtonPrimary = styled(Button)({
	display: 'block',
	marginTop: 8,
})

export const MinusButton = styled(Button)({
	alignSelf: 'center',
	color: colors.brandTextLight,
	borderColor: colors.brandTextLight
})
